module.exports = __webpack_public_path__ + "static/media/zoom-out.0ffc8fb2.svg";